import type { ReactNode } from "react";

export function Switch({ checked, label, disabled, onChange }: { checked: boolean; label: string; disabled?: boolean; onChange: (next: boolean) => void }) {
  return <button type="button" role="switch" aria-checked={checked} aria-label={label} className="bw-switch" disabled={disabled} onClick={() => onChange(!checked)}><span /></button>;
}

/** A setting with a switch: its title, what it does, then the switch. */
export function SwitchRow({ title, hint, checked, disabled, onChange }: { title: string; hint?: ReactNode; checked: boolean; disabled?: boolean; onChange: (next: boolean) => void }) {
  return <div className="bw-area-switch-row">
    <span><strong>{title}</strong>{hint && <small>{hint}</small>}</span>
    <Switch checked={checked} label={title} disabled={disabled} onChange={onChange} />
  </div>;
}
